export const SHIP_TO_ME = 'ship-to-me';
export const SHIP_TO_STORE = 'ship-to-store';
export const DEFAULT_STORE_KEY = 'defaultBopisStore';
